import hasErrorCondition from '../../../utils/has-error-condition';

class CouponCodeController {
	constructor(CouponCodeService, COMMON_CONSTS, $cookies) {
		'ngInject';
		this.couponCodeService = CouponCodeService;
		this.tooltipShow = false;
		this.couponCode = '';
		this.hasError = hasErrorCondition;
		this.COMMON_CONSTS = COMMON_CONSTS;
		this.activationFail = false;
		this.$cookies = $cookies;
	}

	validateCouponCode(toWelcome) {
		this.couponCodeService.validateCouponCode(this.couponCode)
			.then(() => {
				this.successCallback();

				if (toWelcome) {
					this.$cookies.put('saveCompanySuccess', true, {path: '/'});
					this.$cookies.put('couponValid', true, {path: '/'});
					window.location.href = '/welcome/company';
				}
			})
			.catch(() => {
				this.activationFail = true;
			})
	}

	cancelCouponEntry() {
		window.location.href = '/welcome/company';
	}

	showTooltip() {
		this.tooltipShow = true;
	}

	hideTooltip() {
		this.tooltipShow = false;
	}
}

export default CouponCodeController;
